import { render, staticRenderFns } from "./SolicitacaoBaixas.vue?vue&type=template&id=4b58513c"
import script from "./SolicitacaoBaixas.vue?vue&type=script&lang=js"
export * from "./SolicitacaoBaixas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports